import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    width: "-webkit-fill-available",
    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar + 1,
    alignItems: "center",
    padding: theme.spacing.space16,
    paddingTop: theme.spacing.space16,
    paddingLeft: theme.spacing.space16,
  },
  transparentBg: {
    background: "transparent !important",
  },
  centerContent: {
    position: "absolute",
    left: "50%",
    transform: "translate(-50%)",
  },
}));
